import {Module} from "vuex";
import {RootState} from "@/store/types";
import {BeruState} from "@/store/beru/types";
import getters from "@/store/beru/getters";
import mutations from "@/store/beru/mutations";
import actions from "@/store/beru/actions";

const beru:Module<BeruState, RootState> = {
    namespaced: true,
    state: {
        beru_rates: null,
        exchange_free: null,
        exchange_taken: null,
        exchange_free_meta: null,
        exchange_taken_meta: null,
        close_reasons: [],
        close_type_reasons: [],
        beru_detail: null,
    },
    getters: getters,
    mutations: mutations,
    actions: actions
}

export default beru